import React from 'react'
import { Route, Switch } from 'react-router'
import InvoicingInvoices from './InvoicingInvoices'
import InvoicingInvoicesEdit from './InvoicingInvoicesEdit'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={InvoicingInvoices} />
        <Route exact path={`${props.match.url}/new`} component={InvoicingInvoicesEdit} />
        <Route exact path={`${props.match.url}/:invoiceID`} component={InvoicingInvoicesEdit} />
        <Route exact path={`${props.match.url}/:invoiceID/credit-note`} component={InvoicingInvoicesEdit} />
    </Switch>
)

export default Components
